import { useCallback, useEffect } from "react"
import { useSignal } from "@preact/signals-react"
import { sitesModalData } from "@signals"


export default function useSiteModalFilter() {
	const filteredList = useSignal([])
	const filteredSites = useSignal("")
	const countriesOptions = useSignal([])

	useEffect(() => {
		filteredList.value = sitesModalData.value
	}, [sitesModalData.value])

	const applyFilters = () => {
		const searchTerm = filteredSites.value?.toLowerCase() || ''
		filteredList.value = sitesModalData.value.filter(({ name, type, country }) => {
			const matchesSearchTerm = searchTerm ? name.toLowerCase().includes(searchTerm) : true
			const matchesCountry = countriesOptions.value.length
				? countriesOptions.value.some(option => country?.toLowerCase().includes(option.toLowerCase()))
				: true
			return matchesSearchTerm && matchesCountry
		})
	}

	const onChangeSite = useCallback(e => {
		filteredSites.value = e.target.value
	}, [])

	const onChangeCountry = useCallback(e => {
		countriesOptions.value = e.target.value
	}, [])

	return {
		filteredList: filteredList.value,
		filteredSites: filteredSites.value,
		countriesOptions: countriesOptions.value,
		applyFilters,
		onChangeSite,
		onChangeCountry,
	}
}